import { actions } from '../../utils/constants';

const DEFAULT_STATE = {
    test: {},
    questions: [],
};

export default (state = DEFAULT_STATE, { type, payload }) => {
    switch (type) {
        case actions.CHANGE_TEMPLATE_TESTS_TO_DUPLICATE:
            return { ...state, test: payload };
        case actions.CHANGE_QUESTIONS_TEMPLATE_TESTS_TO_DUPLICATE:
            return { ...state, questions: payload };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/components/duplicate-template-test/duplicate-template-test.reducer.js